import { OwcTypography } from '@one/react';
import React from 'react';
import { ErrorContainer } from './error-app.style';

export const ErrorAppComponent: React.FC = () => (
  <ErrorContainer>
    <OwcTypography variant="title1">404</OwcTypography>
    <OwcTypography variant="title3">Oops! Not Found</OwcTypography>
  </ErrorContainer>
);
